import {deleteAction, getAction, postAction, putAction, downFile} from '@/api/manage'

export const addCloudClassroom = parameter=>postAction(`/train/cloud-classroom`,parameter);

export const getCloudClassroomPage = parameter=>getAction(`/train/cloud-classroom`,parameter);

